import {useCallback, useEffect, useRef, useState} from "react";

import {fetchUserProfileAfterAuth} from "../../auth/actions/fetch_user_profile_after_auth";
import {closeFlow} from "../../auth/state/registration_flow_slice";
import {RegistrationFlowStep} from "../../auth/types/RegistrationFlowStep";
import {useShouldHidePrices} from "../../hooks/use_should_hide_prices";
import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {closeAuthDrawer, openPhoneVerificationStep} from "../state/semantic_search_auth_slice";

/**
 * After login/registration: waits for the profile of the authenticated user, then on the next render reads
 * {@link useShouldHidePrices} (verified phone, etc.) and, while the login or sign-up drawer is still open, either
 * closes the overlay or proceeds to the PIN step.
 */
export const useSemanticSearchPostAuthNavigation = () => {
    const dispatch = useAppDispatch();
    const registrationFlow = useAppSelector((state) => state.registrationFlow);
    const activeDrawer = useAppSelector((state) => state.semanticSearchAuth.activeDrawer);
    const {hasPhoneVerified, isUserLoggedIn} = useShouldHidePrices();

    const [postAuthCheckId, setPostAuthCheckId] = useState(0);
    const processedCheckIdRef = useRef(0);

    const completeAuthFlow = useCallback(async () => {
        await dispatch(fetchUserProfileAfterAuth());
        setPostAuthCheckId((id) => id + 1);
    }, [dispatch]);

    useEffect(() => {
        if (postAuthCheckId === 0 || postAuthCheckId === processedCheckIdRef.current) {
            return;
        }

        processedCheckIdRef.current = postAuthCheckId;

        if (activeDrawer !== "login" && activeDrawer !== "signup") {
            return;
        }

        if (!isUserLoggedIn || hasPhoneVerified) {
            dispatch(closeAuthDrawer());
            return;
        }

        if (
            registrationFlow.isActive &&
            (registrationFlow.currentStep === RegistrationFlowStep.PHONE_VERIFICATION || registrationFlow.currentStep === RegistrationFlowStep.PHONE_COMPLETION)
        ) {
            dispatch(closeFlow());
        }
        dispatch(openPhoneVerificationStep());
    }, [postAuthCheckId, activeDrawer, hasPhoneVerified, isUserLoggedIn, registrationFlow.isActive, registrationFlow.currentStep, dispatch]);

    return {completeAuthFlow};
};
import {useCallback, useEffect, useRef, useState} from "react";

import {fetchUserProfileAfterAuth} from "../../auth/actions/fetch_user_profile_after_auth";
import {closeFlow} from "../../auth/state/registration_flow_slice";
import {RegistrationFlowStep} from "../../auth/types/RegistrationFlowStep";
import {useShouldHidePrices} from "../../hooks/use_should_hide_prices";
import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {closeAuthDrawer, openPhoneVerificationStep} from "../state/semantic_search_auth_slice";

/**
 * After login/registration: waits for the profile of the authenticated user, then on the next render reads
 * {@link useShouldHidePrices} (verified phone, etc.) and, while the login or sign-up drawer is still open, either
 * closes the overlay or proceeds to the PIN step.
 */
export const useSemanticSearchPostAuthNavigation = () => {
    const dispatch = useAppDispatch();
    const registrationFlow = useAppSelector((state) => state.registrationFlow);
    const activeDrawer = useAppSelector((state) => state.semanticSearchAuth.activeDrawer);
    const {hasPhoneVerified, isUserLoggedIn} = useShouldHidePrices();

    const [postAuthCheckId, setPostAuthCheckId] = useState(0);
    const processedCheckIdRef = useRef(0);

    const completeAuthFlow = useCallback(async () => {
        await dispatch(fetchUserProfileAfterAuth());
        setPostAuthCheckId((id) => id + 1);
    }, [dispatch]);

    useEffect(() => {
        if (postAuthCheckId === 0 || postAuthCheckId === processedCheckIdRef.current) {
            return;
        }

        processedCheckIdRef.current = postAuthCheckId;

        if (activeDrawer !== "login" && activeDrawer !== "signup") {
            return;
        }

        if (!isUserLoggedIn || hasPhoneVerified) {
            dispatch(closeAuthDrawer());
            return;
        }

        if (
            registrationFlow.isActive &&
            (registrationFlow.currentStep === RegistrationFlowStep.PHONE_VERIFICATION || registrationFlow.currentStep === RegistrationFlowStep.PHONE_COMPLETION)
        ) {
            dispatch(closeFlow());
        }
        dispatch(openPhoneVerificationStep());
    }, [postAuthCheckId, activeDrawer, hasPhoneVerified, isUserLoggedIn, registrationFlow.isActive, registrationFlow.currentStep, dispatch]);

    return {completeAuthFlow};
};
